(function($) {

    $( document ).ready((function() {
        headerMenuToggle();
        addHeaderListener();
        addFilterItemListener(false);
        relatedProductsSlider();
        videoRowSlider();
        videoModalData();
        reviewSlider();
        testimonialSlider();
        featuredProducts();
    }));

    function headerMenuToggle() {
        var $navContainer = $('#site-navigation'),
            $mobileMenu   = $navContainer.find('.c-header_mobile-menu'),
            $toggle       = $('.c-header .menu-toggle');
            
        $toggle.attr( 'aria-expanded', 'false' );
        $mobileMenu.attr( 'aria-expanded', 'false' );
        
        $toggle.click((function(e) {
            $navContainer.toggleClass('toggled');
            
            var isExpanded = $navContainer.hasClass('toggled');
            
            $toggle.attr('aria-expanded', isExpanded);
            $mobileMenu.attr('aria-expanded', isExpanded);
        }));
    }
        
    // Function to return all instances of WooCommerce Product Search filter headers
    // Heavily reliant on the plugins class names, so pending updates may require refactoring 
    // Params: N/A
    // Returns: Collection of jQuery DOM elements
    function getFilterHeaders() {
        return $('#secondary .product-search-filter-terms-heading');
    }

    // Function to return all instances of WooCommerce Product Search filters
    // Heavily reliant on the plugins class names, so pending updates may require refactoring 
    // Params: N/A
    // Returns: Collection of jQuery DOM elements
    function getFilterListItems() {
        return $('#secondary .product-search-filter-items li');
    }

    function addFilterHeaderCarets($filterHeader) {
        var downCaret = '<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="chevron-down" class="svg-inline--fa fa-chevron-down fa-w-14 filter-header-toggle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M441.9 167.3l-19.8-19.8c-4.7-4.7-12.3-4.7-17 0L224 328.2 42.9 147.5c-4.7-4.7-12.3-4.7-17 0L6.1 167.3c-4.7 4.7-4.7 12.3 0 17l209.4 209.4c4.7 4.7 12.3 4.7 17 0l209.4-209.4c4.7-4.7 4.7-12.3 0-17z"></path></svg>';
        if($filterHeader.find('.filter-header-toggle').length === 0) {
            $filterHeader.append(downCaret);
        }
    }

    // Function to add carets to the headers of the WooCommerce Product Search filters and declare click events on them
    // Params: Boolean
    // Returns: N/A
    function addHeaderListener() {

        var $filterHeaders   = getFilterHeaders();
        var tabletSize = window.matchMedia('(max-width: 768px)');
        
        $filterHeaders.each((function(index, value) {

            var $itemList = $(value).siblings('.product-search-filter-items');

            if(tabletSize.matches) {
                addFilterHeaderCarets($(value));
            }

            if(tabletSize.matches) {

                // Hide the list items if on mobile
                setTimeout((function() {
                $itemList.css("display", "none")
                }), 100);

            }

        }));

        // Add Click event to the headers to allow them to expand
        $filterHeaders.off("click").on("click", (function(event) {

            var $itemList      = $(this).siblings('.product-search-filter-items');
            var elementOffset  = ($(this).offset().top - $(this).height())
            
            if(tabletSize.matches) {

                if($itemList.hasClass('is-open')) {
                    $itemList.removeClass('is-open');
                }
                else {
                    // Scroll to the top of the filter heading to offset the issue where list items
                    // appear to slide up instead of going down
                    $([document.documentElement, document.body]).animate({
                        scrollTop: elementOffset
                    }, 300);

                    $itemList.addClass('is-open');
            
                }
                
                // Toggle the slide menu display
                $itemList.slideToggle(300);

                // Wait until now to call this function to ensure all AJAX functions have been called
                addFilterItemListener(true);
            }

        }));

        // Close or open all of the filter item menus on change of breakpoint
        tabletSize.addListener((function(e) {
            $itemList = $(this).siblings('.product-search-filter-items');
            if( e.matches ) {
                $filterHeaders.each((function(index, value) {
                    addFilterHeaderCarets($(value));
                    $itemList = $(this).siblings('.product-search-filter-items');
                    $itemList.css('display', 'none');

                }));
            }
            else {
                $filterHeaders.each((function(index, value) {
                    $itemList = $(this).siblings('.product-search-filter-items');
                    $itemList.css('display', 'block');
                    $itemList.removeClass('is-open');
                }));
            }
        }));

    }

    // Function to call listener on AJAX events on the archive page
    // When a filter is selected in Woocommerce Product Search, the content is AJAx'd 
    // in causing existing elements to lose their changes from addFilterHeaderCarets
    // Params: boolean
    function addFilterItemListener(refreshed) {
        var archivePage = $('.post-type-archive-product');

        if(archivePage && refreshed) {
            $(document).ajaxComplete((function() {

                addHeaderListener();
                $filterListItems = getFilterListItems();
                $filterListItems.each((function(index, value) {
                    // If a filter list contains a "Clear", ensure that it isn't closed when filtered
                    if($(value).hasClass('nav-back')) {
                        setTimeout((function() {
                            $(value).parent().css('display', 'block');
                            $(value).parent().addClass('is-open');
                        }), 100)
                    }
                }))

            }));
        }
    }

    function relatedProductsSlider() {

        var $relatedProducts = $('.related.products .products'),
            isCart = $('.woocommerce-cart').length >= 1,
            column_count = isCart ? 2 : 4;
        

        if(!$relatedProducts.length) return
        
        // SVG used for arrows to allow for Slick native behavior of not including arrows when # of slides
        // is less than slidesdToShow
        // https://github.com/kenwheeler/slick/issues/1403#issuecomment-108245626
        $relatedProducts.slick({
            dots: false,
            infinite: false,
            speed: 300,
            prevArrow: '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left" class="svg-inline--fa arrowPrev slick-prev fa-chevron-left fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="#000000" d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"></path></svg>',
    	    nextArrow: '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-right" class="svg-inline--fa arrowNext slick-next fa-chevron-right fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill=""#000000" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"></path></svg>',
            slidesToShow: column_count,
            slidesToScroll: 1,
            adaptiveHeight: true,
            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: isCart ? 1 : 3,
                    adaptiveHeight: true
                  }
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: isCart ? 1 : 2,
                    adaptiveHeight: true
                  }
                },
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 1,
                    adaptiveHeight: true
                  }
                }
            ]
        });
    }

    // Implement Slick Slider for Video Rows
    function videoRowSlider() {

        var $videoSlides = $('.c-video_slider .c-video_slider-slide');
        

        if(!$videoSlides.length) return
        
        // SVG used for arrows to allow for Slick native behavior of not including arrows when # of slides
        // is less than slidesdToShow
        // https://github.com/kenwheeler/slick/issues/1403#issuecomment-108245626
        
        $('.c-video_slider-slides').slick({
            dots: false,
            infinite: false,
            speed: 300,
            prevArrow: '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left" class="svg-inline--fa arrowPrev slick-prev fa-chevron-left fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"></path></svg>',
    	    nextArrow: '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-right" class="svg-inline--fa arrowNext slick-next fa-chevron-right fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"></path></svg>',
            slidesToShow: 3,
            slidesToScroll: 1,
            adaptiveHeight: true,
            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    adaptiveHeight: true
                  }
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 2,
                    adaptiveHeight: true
                  }
                },
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 1,
                    adaptiveHeight: true
                  }
                }
            ]
        });

    }

    function videoModalData() {
        var $resourceModal  = $('#videoModal'),
            $modalTriggers  = $('*[data-micromodal-trigger="videoModal"]'),
            $iframe         = $resourceModal.find('iframe');

        MicroModal.init({
            onClose: function() {$iframe.attr({src: ''})},
        });

        $modalTriggers.click((function(e) {
            var $videoUrl = $(e.currentTarget).attr('data-video-url');
            $iframe.attr({
                src: $videoUrl
            })
        }))
    }

    // Implement Slick Slider for Review Slider
    function reviewSlider() {
        var $reviewSlider = $('.c-review-slider_container');

        $reviewSlider.slick({
            autoplay: true,
            autoplaySpeed: 8000,
            dots: false,
            prevArrow: '<div class="c-review-slider_prevnext"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left" class="svg-inline--fa arrowPrev slick-prev fa-chevron-left fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"></path></svg></div>',
            nextArrow: '<div class="c-review-slider_prevnext"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-right" class="svg-inline--fa arrowNext slick-next fa-chevron-right fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"></path></svg></div>',
        });
    }

    // Implement Slick Slider for Testimonial Slider
    function testimonialSlider() {
        var $slider         = $('.c-testimonial-slider_container'),
            $arrow_color    = $slider.data('arrow-color'),
            $display_arrows = $slider.data('arrow-display');

        var $slickObject = {
            autoplay: true,
            autoplaySpeed: 8000,
            dots: true,
            dotsClass: 'c-testimonial-slider_dots slick-dots',
        };

        // Add Arrows if toggled by user
        if( $display_arrows ) {
            $slickObject['prevArrow'] = '<div class="c-testimonial-slider_prevnext"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left" class="svg-inline--fa arrowPrev slick-prev fa-chevron-left fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="' + $arrow_color + '" d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"></path></svg></div>'
            $slickObject['nextArrow'] = '<div class="c-testimonial-slider_prevnext"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-right" class="svg-inline--fa arrowNext slick-next fa-chevron-right fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="' + $arrow_color + '" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"></path></svg></div>'
        }

        $slider.slick($slickObject);
    }

    // Implement Slick Slider for Featured Products
    function featuredProducts() {
        var $productSlider = $('.c-featured-products_slider');
        
        $productSlider.slick({
            autoplay: true,
            autoplaySpeed: 8000,
            dots: true,
            dotsClass: 'c-featured-products_dots slick-dots',
            speed: 300,
            prevArrow: '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left" class="svg-inline--fa arrowPrev slick-prev fa-chevron-left fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"></path></svg>',
    	    nextArrow: '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-right" class="svg-inline--fa arrowNext slick-next fa-chevron-right fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"></path></svg>',
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 2,
                  }
                },
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 1,
                  }
                }
            ]
        });

    }
})(jQuery);
